<template>
    <div>
        <div class="row"  v-show="loading">
            <div class="col-sm-12 text-center">
                <span><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
            </div>
        </div>
        <div class="row"  v-show="!loading">
            <div class="col-sm-6">
                <div class="form-group">
                    <label for="remainingAt">Au</label>
                    <div class="ix-datepicker-wrapper">
                        <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa" id="remainingAt" v-model="form.date_at">
                    </div>
                    <span class="ix-text-small ix-text-secondary" v-if="form.minDate">Date du dernier reste à faire: {{ form.minDate }}</span>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label for="global">Avancement global</label>
                    <div class="input-group">
                        <input type="number" class="form-control form-control text-right" v-model="form.globalRemaining" step="0.01">
                        <div class="input-group-append">
                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>  <button class="ix-btn ix-btn-icon blue" type="button" @click="updateAllRemaining()" title="Mettre à jour tout les restes à faires">
                                Appliquer 
                             </button>
                        </div>
                    </div>
                    <span class="ix-text-small ix-text-secondary" v-if="form.globalAvancement">Dernier avancement global : {{ form.globalAvancement }}%</span>
                </div>
            </div>
            <div class="col-sm-12">
                <div>
                    <b-card no-body>
                        <b-tabs pills card vertical>
                        <b-tab>
                            <template #title>
                                Non allotis  <br>
                                <small v-if="form.last_progress != null">Dernier avancement: {{ Math.ceil(form.last_progress) }}%</small>
                            </template>
                            <b-card-text>
                                <div class="row">
                                    <div class="col-sm-4 offset-md-8">
                                            <div class="input-group">
                                                <input type="number" class="form-control form-control-sm text-right" v-model="form.progress" step="0.01" @input="computePercentAttribute($event ,form.items)">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>  
                                                </div>
                                            </div>
                                            <span class="ix-text-small ix-text-secondary" v-if="form.last_progress != null">Dernier avancement: {{ Math.ceil(form.last_progress) }}%</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="ix-table-box mt-4">
                                            <table class="ix-table">
                                                <tbody v-for="(type) in types" v-bind:key="type.value">
                                                    <tr class="ix-table-row-secondary">
                                                        <td class="ix-text-bold"><i v-bind:class="type.icon"></i> {{ type.label }}</td>
                                                        <td style="width: 130px;"></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td class="ix-text-large ix-text-bold text-right">
                                                            {{ currency(getTypeTotal(type.value)) }}
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="ix-text-small ix-text-secondary">Désignation</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb jours / personne" : "Quantité" }}</span>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Taux horaire" : "Prix unitaire" }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb heures / jour" : "" }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb heures total" : "" }}</span>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="ix-text-small ix-text-secondary">Total</span>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr v-for="(item, index) in filterItems(form.items, type.value)" v-bind:key="index">
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm" v-model="item.designation" placeholder="Désignation" :id="'designation' + item.uniq">
                                                    </td>

                                                    <td>
                                                        <input type="number" class="form-control form-control-sm text-center" v-model="item.quantity" step="0.001" @input="computeAttribute(item, 'total')" @keyup.enter="enterPressed">
                                                    </td>

                                                    <td class="text-right">
                                                        <div class="input-group">
                                                            <input type="number" class="form-control form-control-sm text-right" v-model="item.amount" step="0.001" @input="computeAttribute(item, 'total')" @keyup.enter="enterPressed">
                                                            <div class="input-group-append">
                                                                <span class="input-group-text" id="inputGroup-sizing-sm">€{{ item.type == 1 ? ' / h' : '' }}</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <input type="number" class="form-control form-control-sm text-center" v-model="item.extra" step="0.001" @input="computeAttribute(item, 'total')" @keyup.enter="enterPressed" v-if="item.type == 1">
                                                    </td>

                                                    <td>
                                                        <input type="number" class="form-control form-control-sm text-center" v-model="item.total_hours" step="0.001" @input="computeAttribute(item, 'total_hours')" @keyup.enter="enterPressed" v-if="item.type == 1">
                                                    </td>

                                                    <td class="text-right">
                                                        <div class="input-group">
                                                            <input type="number" class="form-control form-control-sm text-right" v-model="item.total" step="0.001" placeholder="Total" @input="computeAttribute(item, 'quantity')" @keyup.enter="enterPressed">
                                                            <div class="input-group-append">
                                                                <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-right">
                                                        <span class="btn btn-sm transparent" @click="deleteItem(item.uniq)">
                                                            <i class="far fa-trash"></i>
                                                        </span>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="ix-text-bold" colspan="100%">
                                                            <button class="ix-btn link" @click="addDealRemainingItem(null, type.value)">
                                                                <i class="far fa-plus"></i> Ajouter
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-card-text>
                        </b-tab>
                        <b-tab :active="index === 0" v-for="(lot, index) in form.lotItems" :key="index">
                            <template #title>
                                {{ lot['name'] }} <br>
                                <small v-if="lot.last_progress != null">Dernier avancement: {{ Math.ceil(lot.last_progress) }}%</small>
                            </template>
                            <b-card-text>
                                <div class="row">
                                    <div class="col-sm-4 offset-md-8" v-if="lot.progress != null">
                                        <div class="input-group">
                                            <input type="number" class="form-control form-control-sm text-right" v-model="lot.progress" step="0.01" @input="computePercentAttribute($event ,lot.items)">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                            </div>
                                        </div>
                                        <span class="ix-text-small ix-text-secondary" v-if="lot.last_progress != null">Dernier avancement: {{ Math.ceil(lot.last_progress) }}%</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="ix-table-box mt-4">
                                            <table class="ix-table">
                                                <tbody v-for="(type, typeIndex) in types" v-bind:key="typeIndex">
                                                    <tr class="ix-table-row-secondary">
                                                        <td class="ix-text-bold"><i v-bind:class="type.icon"></i> {{ type.label }}</td>
                                                        <td style="width: 130px;"></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td class="ix-text-large ix-text-bold text-right">
                                                            {{ currency(getLotTypeTotal(type.value, index)) }}
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="ix-text-small ix-text-secondary">Désignation</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb jours / personne" : "Quantité" }}</span>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Taux horaire" : "Prix unitaire" }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb heures / jour" : "" }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="ix-text-small ix-text-secondary">{{ type.value == 1 ? "Nb heures total" : "" }}</span>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="ix-text-small ix-text-secondary">Total</span>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr v-for="(item, i) in filterItems(lot.items, type.value)" v-bind:key="i">
                                                        <td>
                                                            <input type="text" class="form-control form-control-sm" v-model="item.designation" placeholder="Désignation" :id="'designation' + item.uniq">
                                                        </td>
                                                        <td>
                                                            <input type="number" class="form-control form-control-sm text-center" v-model="item.quantity" step="0.001" @input="computeAttribute(item, 'total', index)" @keyup.enter="enterPressed">
                                                        </td>
                                                        <td class="text-right">
                                                            <div class="input-group">
                                                                <input type="number" class="form-control form-control-sm text-right" v-model="item.amount" step="0.001" @input="computeAttribute(item, 'total', index)" @keyup.enter="enterPressed">
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" id="inputGroup-sizing-sm">€{{ item.type == 1 ? ' / h' : '' }}</span>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <input type="number" class="form-control form-control-sm text-center" v-model="item.extra" step="0.001" @input="computeAttribute(item, 'total', index)" @keyup.enter="enterPressed" v-if="item.type == 1">
                                                        </td>

                                                        <td>
                                                            <input type="number" class="form-control form-control-sm text-center" v-model="item.total_hours" step="0.001" @input="computeAttribute(item, 'total_hours', index)" @keyup.enter="enterPressed" v-if="item.type == 1">
                                                        </td>

                                                        <td class="text-right">
                                                            <div class="input-group">
                                                                <input type="number" class="form-control form-control-sm text-right" v-model="item.total" step="0.001" placeholder="Total" @input="computeAttribute(item, 'quantity', index)" @keyup.enter="enterPressed">
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="btn btn-sm transparent" @click="deleteLotItem(item.uniq, index)">
                                                                <i class="far fa-trash"></i>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="ix-text-bold" colspan="100%">
                                                            <button class="ix-btn link" @click="addDealLotRemainingItem(type, index)">
                                                                <i class="far fa-plus"></i> Ajouter
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-card-text>
                        </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </div>

        <div class="row mt-2" v-show="!loading">
               <div class="col-sm-12 text-right">
                   <button type="button" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm" @click="updateRemainings()">
                           <span v-if="!loadingForm">Enregistrer</span>
                           <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i> Mise à jour en cours</span>
                   </button>
               </div>
           </div>
    </div>
</template>

<script>

import { forEach } from 'lodash';
import VueSwal from 'vue-swal'

export default {
    name: 'deal-lot-progress',
    props: ['suggestionsRoute', 'formRoute', 'setupRoute', 'destroyRoute' ,'marginType', 'canDelete', 'redirectRoute'],
    data(){
        return {
            form: {
                date_at: this.moment().format('DD/MM/YYYY'),
                minDate: null, 
                lotItems: [],
                items: [],
                progress: 0,
                last_progress: 0,
                globalAvancement: 0,
                globalRemaining:0,
            },
            types: [
                    {label: "Main d'oeuvre", icon: "far fa-user", value: 1},
                    {label: "Achats", icon: "far fa-shopping-bag", value: 2},
                    {label: "Stocks", icon: "far fa-cube", value: 3},
                    {label: "Matériels", icon: "far fa-cog", value: 4},
            ],

            settings: {
                hours_per_day: 7,
                hourly_rate: 40
            },

            
            showError: false,
            loading: false,
            loadingForm: false,


            arrayRemainings: [],
            arrayLotRemainings: [],
            allArrayRemainings: [],
           
        }
    },
    methods: {
        computeAttribute: function(item, attribute, indexLot = null) {
            if (attribute == 'total') {
                item.total = this.roundCurrency(item.quantity * item.amount * item.extra, 2)
                if (item.type == 1) item.total_hours = this.roundCurrency(item.quantity * item.extra, 2)
            } else if (attribute == 'total_hours') {
                if (item.extra != 0) {
                    item.quantity = this.roundCurrency(item.total_hours / item.extra, 2)
                }
                item.total = this.roundCurrency(item.quantity * item.amount * item.extra, 2)
            } else {
                if (item.type == 1) item.total_hours = this.roundCurrency(item.quantity * item.extra, 2)
            }

            var prev = 0;
            var raf = 0;
            if(indexLot){
                this.form.lotItems[indexLot].items.forEach((item, i) => {
                    prev += item.init_total;
                    raf += Number(item.total);
                }); 
                this.form.lotItems[indexLot].progress = parseFloat(((prev - raf) / prev) * 100).toFixed(2);
            } else {
                this.form.items.forEach((item, i) => {
                    prev += item.init_total;
                    raf += Number(item.total);
                })

                
                this.form.progress = parseFloat(((prev - raf) / prev) * 100).toFixed(2);
            }
        },
        computePercentAttribute: function(e, items = null){
            const percent = e.target.value;
            if(items && percent != 0){
                var ratio = (percent/100);
                items.forEach((item,index) => {
                    item.total = item.init_total - (ratio * item.init_total);
                 //   item.amount = item.init_amount - (ratio * item.init_amount);
                   // item.quantity = item.init_quantity - (ratio * item.init_quantity);
                    item.extra = item.init_extra - (ratio * item.init_extra);
                });
            } else {
                items.forEach((item,index) => {
                    item.total = item.init_total
                    item.amount = item.init_amount
                    item.quantity = item.init_quantity
                    item.extra = item.init_extra
                });
            }
        },
        updateAllRemaining(){

            this.$swal({
                    title : "Attention",
                    text : "Etes vous sûr de vouloir appliquer ce pourcentage d’avancement à l’ensemble des postes ?",
                    icon : "warning",
                    buttons : ["Non" , "Oui"]
                }).then((willDo) => {
                    if(willDo){
                        const event = { target: { value: this.form.globalRemaining } };
                        console.log(event);
                        // Non allotis
                        if(this.form.items && this.form.items.length > 0){
                            this.computePercentAttribute(event, this.form.items);  
                            this.form.progress = this.form.globalRemaining;
                        }

                        if(this.form.lotItems && this.form.lotItems.length > 0){
                            this.form.lotItems.forEach((lot, i) => {
                                this.computePercentAttribute(event, this.form.lotItems[i].items);
                                this.form.lotItems[i].progress = this.form.globalRemaining;
                            })
                        }
                    }
                });

        },
        getTypeTotal: function(type) {
            var total = 0;
            this.form.items.filter(item => item.type == type).forEach(item => total += parseFloat(item.total));
            return total;
        },
        getLotTypeTotal: function(type, indexLot) {
            var total = 0;
            this.form.lotItems[indexLot].items.forEach(lot => {
                if(type == lot.type){
                     total += parseFloat(lot.total)
                }
            })
            return total;
        },
        filterItems: function(items, type) {
            return items.filter(item => item.type == type)
        },
        deleteItem: function(uniq) {
            var index = this.form.items.findIndex(item => {
                    return item.uniq == uniq
            })

            if(index >= 0) {
                this.form.items.splice(index, 1)
            }
        },
        deleteLotItem: function(uniq, indexLot){
            var index = this.form.lotItems[indexLot].items.findIndex(item => {
                return item.uniq == uniq
            })
            if(index >= 0) {
                this.form.lotItems[indexLot].items.splice(index, 1)
            }
        },
        enterPressed: function() {
                if (this.checkForm() == true) {
                    this.updateRemainings()
                }
        },
        addDealRemainingItem: function(item, type) {
                var qty   = item ? item.quantity : 1;
                var extra = item ? item.extra : (type == 1 ? this.settings.hours_per_day : 1);
                var data = {
                    uniq: Math.random().toString(36).substr(2, 9),
                    type: type,
                    designation: item ? item.designation : '',
                    total: item ? item.total : 0,

                    quantity: qty,
                    amount: item ? item.amount : (type == 1 ? this.settings.hourly_rate : 0),
                    extra: extra,
                    total_hours: type == 1 ? this.roundCurrency(qty * extra, 2) : 0,
                    lot: item && item.lot ? item.lot : null,
                    progress: item ? item.progress : null,
                    init_total: item ? item.total : 0,
                    init_quantity: qty,
                    init_amount: item ? item.amount : (type == 1 ? this.settings.hourly_rate : 0),
                    init_extra: extra,
                }


                this.form.items.push(data);
                this.computeAttribute(data, 'total')

                setTimeout(() => {
                    if (item == null) {
                        $('#designation' + data.uniq).focus()
                    }
                    
                    this.initAutocomplete(data.uniq)
                }, 250)

        },
        addDealLotRemainingItem: function(type, indexLot){
            var data = {
                uniq: Math.random().toString(36).substr(2, 9),
                type: type.value,
                designation: '',
                total: 0,
                quantity: 1,
                amount: type.value == 1 ? this.settings.hourly_rate : 0,
                extra: type.value == 1 ? this.settings.hours_per_day : 1,
                total_hours: type.value == 1 ? this.settings.hours_per_day : 0,
                init_total:  0,
                init_quantity: 1,
                init_amount: type.value == 1 ? this.settings.hourly_rate : 0,
                init_extra: type.value == 1 ? this.settings.hours_per_day : 1,
            }
            this.computeAttribute(data, 'total')
            this.form.lotItems[indexLot].items.push(data);

            this.$set(this.form.lotItems, indexLot, this.form.lotItems[indexLot]);
            setTimeout(() => {
                this.initLotAutocomplete(data.uniq, indexLot);
            }, 250)

        },
        initAutocomplete: function(uniq) {
                var vm = this

                $("#designation" + uniq).autocomplete({
                    minLength: 2,
                    source: (request, response) => {
                        $.ajax({
                            url : this.suggestionsRoute,
                            type: 'get',
                            dataType : 'json',
                            headers: this.getHttpJsonRequestHeaders().headers,
                            data: {...{ q: request.term }, ...{deal_id: $('#deal_id').val()}},
                            success: (data) => {
                                response($.map(data, (item) => {
                                    return Object.assign(item, {
                                        label: item.designation,
                                        value: item.designation,
                                        formatted_amount: this.currency(item.amount)
                                    })
                                }))
                            }
                        });
                    },
                    create: function () {
                        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                            return $('<li>')
                                .append(vm.studySuggestionItemHtml(item))
                                .appendTo(ul);
                        };
                    },
                    select: (e, item) => {
                        var index = this.form.items.findIndex(item => {
                            return item.uniq == uniq
                        })

                        if(index >= 0) {
                            this.form.items[index].designation = item.item.designation
                            this.form.items[index].amount = item.item.amount
                            this.computeAttribute(this.form.items[index], 'total')
                        }
                    }
                }).focus(() => {
                    $("#designation" + uniq).autocomplete("search", '');
                });
        },
        initLotAutocomplete: function(uniq, lotIndex) {
                var vm = this

                $("#designation" + uniq).autocomplete({
                    minLength: 2,
                    source: (request, response) => {
                        $.ajax({
                            url : this.suggestionsRoute,
                            type: 'get',
                            dataType : 'json',
                            headers: this.getHttpJsonRequestHeaders().headers,
                            data: {...{ q: request.term }, ...{deal_id: $('#deal_id').val()}},
                            success: (data) => {
                                response($.map(data, (item) => {
                                    return Object.assign(item, {
                                        label: item.designation,
                                        value: item.designation,
                                        formatted_amount: this.currency(item.amount)
                                    })
                                }))
                            }
                        });
                    },
                    create: function () {
                        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                            return $('<li>')
                                .append(vm.studySuggestionItemHtml(item))
                                .appendTo(ul);
                        };
                    },
                    select: (e, item) => {
                        var index = this.form.lotItems[lotIndex].items.findIndex(item => {
                            return item.uniq == uniq
                        })

                        if(index >= 0) {
                            this.form.lotItems[lotIndex].items[index].designation =  item.item.designation;
                            this.form.lotItems[lotIndex].items[index].amount =  item.item.amount;
                            this.computeAttribute(this.form.lotItems[lotIndex].items[index], 'total')
                        }
                    }
                }).focus(() => {
                    $("#designation" + uniq).autocomplete("search", '');
                });
        },
        checkForm: function() {
            var lotIsOk = [];
            this.form.lotItems.forEach(lot => {
               lotIsOk.push(lot.items.filter(item => item.total === null || item.total === '' || item.designation === '' || item.designation === null).length == 0);
            })
            var noneLotIsOk = this.form.date_at != '' && this.form.items.filter(item => item.total === null || item.total === '' || item.designation === '' || item.designation === null).length == 0

            return !lotIsOk.includes(false) && noneLotIsOk;
        },
        getData: async function() {
                this.loading = true;
                fetch(this.setupRoute, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {

                    if(data.previousLotRemaining && data.previousLotRemaining.length > 0){
                        for (const [key, value] of Object.entries(data.previousLotRemaining)) {
                            this.form.lotItems[key] = value
                            this.$set(this.form.lotItems, key, this.form.lotItems[key]);
                        }

                        this.form.lotItems.forEach((data,index) => {
                            data.items.forEach(item => {
                                item.uniq = Math.random().toString(36).substr(2, 9),
                                item.type =  item.type,
                                item.designation = item ? item.designation : '',
                                item.total = item ? item.total : 0,

                                item.quantity = item ? item.quantity : 1,
                                item.amount = item.amount,
                                item.extra = item.extra,
                                item.lot =  item && item.lot ? item.lot : null,
                                item.init_quantity = item ? item.quantity : 1
                                item.init_amount = item.amount
                                item.init_extra = item.extra
                                item.init_total = item ? item.total : 0
                                item.total_hours = item.type == 1 ? this.roundCurrency(item.quantity * item.extra, 2) : 0
                                setTimeout(() => {
                                    this.initLotAutocomplete(item.uniq, index);
                                }, 250)
                            });
                        })
                    }
                    
                    if(data.previousRemaining && data.previousRemaining.length > 0){
                        data.previousRemaining.forEach(item => {
                            this.addDealRemainingItem(item, item.type)
                        })
                    }


                    if (data.minDate) {
                        this.form.minDate = data.minDate
                        $('#remainingAt').datepicker('setStartDate', data.minDate);
                    }

                    $('#remainingAt').datepicker('setEndDate', this.form.date_at);
                        
                    if(data.progress)
                        this.form.progress = data.progress;
                    else
                        this.form.progress = 0

                    if(data.last_progress)
                        this.form.last_progress = data.last_progress;

                    if(data.globalRemaining)
                        this.form.globalAvancement = data.globalRemaining;


                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
        },
        updateRemainings: async function() {
                this.loadingForm = true
                this.showError = false

                var data = {
                    date_at: this.form.date_at,
                    items: this.form.items,
                    lotItems: this.form.lotItems,
                }

                fetch(this.formRoute, {
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        method : "PUT",
                        body :  JSON.stringify(data)
                    }
                }).then((response) => {
                    if (response.status == 200) {
                        window.location.href = this.redirectRoute;
                    } else {
                        this.loadingForm = false;
                        this.showError = true
                    }

                }).catch(error=> {
                    this.loadingForm = false;
                    console.log(error);
                })
            },
    },
    async mounted(){
        await this.getData();
    }
}
</script>

